/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here... 


function checkLazySize(){
  lazySizes.autoSizer.checkElems();
}
setTimeout(checkLazySize(), 2000);
setTimeout(checkLazySize(), 4000);
setTimeout(checkLazySize(), 6000);


function myCallback (el) {
    lazySizes.autoSizer.checkElems();
}

ScrollReveal().reveal('.home-promo__box', { afterReveal: myCallback });